module.exports = __webpack_public_path__ + "static/feature_startup-bc89aeb61a7704ce028192041adb7e13.png";